import { createSlice } from "@reduxjs/toolkit";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  persist,
  sagaSlice,
} from "./sagaStore";
import catalogService from "../services/allCatDoc";

const initialState: any = {
  list: {
    loading: false,
    error: null,
    data: {},
  },
  status: null,
  barcode: null,
  domain: null,
  isApproved: null,
  createdBy: null,
  createdAt: null,
  modifiedAt: null,
  productName: null,
  isFilterApplied: false,
  page: 1,
};

const Slice: sagaSlice = createSlice({
  ...persist("allCatDocManagement", initialState),
  reducers: {
    ...createSagaReducer("fetchAllCatDoc", "list"),
    updateStatus(state, action) {
      state.status = action.payload;
    },
    updateBarcode(state, action) {
      state.barcode = action.payload;
    },
    updateDomain(state, action) {
      state.domain = action.payload;
    },
    updateIsApproved(state, action) {
      state.isApproved = action.payload;
    },
    updateCreatedBy(state, action) {
      state.createdBy = action.payload;
    },
    updateCreatedAt(state, action) {
      state.createdAt = action.payload;
    },
    updateModifiedAt(state, action) {
      state.modifiedAt = action.payload;
    },
    updateProductName(state, action) {
      state.productName = action.payload;
    },
    updateFilterButton(state, action) {
      state.isFilterApplied = action.payload;
    },
    setpage(state, action) {
      state.page = action.payload;
    },
  },
});

const fetchAllCatDocuments = createAsyncSaga(
  "fetchAllCatDoc",
  Slice,
  catalogService.fetchAllCatDoc,
  [
    "page",
    "limit",
    "status",
    "barcode",
    "domain",
    "isApproved",
    "createdBy",
    "createdAt",
    "modifiedAt",
    "productName",
  ]
);

addSaga(Slice.actions.fetchAllCatDoc.type, fetchAllCatDocuments);

export const {
  fetchAllCatDoc,
  updateStatus,
  updateBarcode,
  updateDomain,
  updateCreatedAt,
  updateModifiedAt,
  updateFilterButton,
  updateIsApproved,
  updateCreatedBy,
  setpage,
  updateProductName,
} = Slice.actions;

export default Slice.reducer;
